import { render, staticRenderFns } from "./CostumeCloset.vue?vue&type=template&id=5afd62af&scoped=true"
import script from "./CostumeCloset.vue?vue&type=script&lang=js"
export * from "./CostumeCloset.vue?vue&type=script&lang=js"
import style0 from "./CostumeCloset.vue?vue&type=style&index=0&id=5afd62af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afd62af",
  null
  
)

export default component.exports